import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Details } from 'components/details'
import { Circles } from '../../circles'
import { Title } from './styled'

export const Tatar = forwardRef<HTMLDivElement>((_, ref) => (
  <section ref={ref}>
    <TextContainer>
      <Title data-menu-title='слово "татар"'>
        Откуда появилось слово "татар"
      </Title>

      <Circles align="center">
        <p>
          Впервые слово "татар" стали употреблять примерно в VI-VIII веке
          древнетюркские племена Центральной Азии – на территории современного
          Алтая, Забайкалья, Монголии,{' '}
          <a
            href="https://tatarica.org/ru/razdely/narody/tatary/tatary"
            target="_blank"
            rel="noreferrer"
          >
            указывает
          </a>{' '}
          татарская энциклопедия Tatarika.
        </p>
        <p>
          На орхоно-енисейских камнях, обнаруженных в районе рек Енисей и Орхон (находится в Монголии), в китайских историографических письменах, древнетюркских рунических книгах ученые также нашли многочисленные упоминания слова "татар". Однако до сих пор нет единого мнения о происхождении этого слова. Одни исследователи считают, что слово "татар" произошло от древней реки Тата, протекающей на Востоке, что означает "тянуть, тащить", – к такому выводу пришел итальянский исследователь Плано Карпини, побывавший в 1245 году в районе оседлого проживания древнего народа.
        </p>
      </Circles>
    </TextContainer>

    <Details>
      <TextContainer>
        <p>
          Есть версия, что слово "татар" обозначает количество людей: например, до наших дней дошли такие словосочетания, как "отуз-татар", что в переводе означает "тридцать татар", или "токуз-татар" – "девять татар". Эти слова исследователи обнаружили на надгробных памятниках в районе Беклемишевских озер и в долине реки Ингода, сегодня это территория Читинской области.
        </p>
        <p>
          Другие ученые утверждают, что один из правителей Золотой Орды носил
          имя Татар и оно стало родоначальником для всего народа, находящегося
          под его управлением.
        </p>
        <p>
          Выдвигаются также другие версии происхождения слова: например, "татар"
          – это "чужак".
        </p>
        <p>
          В дипломатической переписке между европейскими и татарскими
          правителями накануне войны 1241 года впервые появляется слово "татар".
          Рассказывая о масштабном вторжении татар в Западную Европу, Фома
          Сплитский в своей книге об истории архиепископов описывает
          завоевателей как народ, получивший свое название от реки Тата. Король
          Германии Фридрих II провел успешные переговоры с татарским правителем
          и убедил его изменить первоначальные планы по вторжению в Германию.
          Поэтому основная тяжесть войны с татарами легла на Венгрию. В
          Ватиканской апостольской библиотеке хранится "Письмо брата Юлиана о
          Монгольской войне", в котором говорится о том, что татарский хан
          предъявляет ультиматум накануне войны венгерскому королю, требует
          сложить оружие и беспрекословно подчиниться.
        </p>
        <p>
          В XIII-XV веках "татарами" называли уже людей из военного сословия
          Золотой Орды. А после ее распада так именовала себя только знать в
          тюрко-татарских государствах.
        </p>
        <p>
          Все изменилось в XV-XVII веках, когда Русское государство завоевало и
          присоединило татарские ханства Волго-Уральского региона и Западной
          Сибири. После этого была полностью разрушена вся политическая система
          тюрко-татарских государств, все представители военной знати были
          понижены в статусе. Даже единая культура была разделена по
          территориальному признаку. При этом значительную часть исконно
          мусульманского населения насильно заставили принять христианство.
          После всех этих событий термин "татарин", "татары" стал обозначать
          лишь принадлежность к определенному этносу в составе Русского
          государства.
        </p>
      </TextContainer>
    </Details>
  </section>
))
